const comments = [
  {
    name: '视频爱好者小王',
    text: '国产91视频这个平台真的很方便，久久视频和芒果视频的入口都整合在一起了，不用一个个去找，省了不少时间。每日更新也很及时，推荐给喜欢在线看视频的朋友们。',
    time: '3天前',
  },
  {
    name: '资深影迷老张',
    text: '用了国产91视频快半年了，97视频和丝瓜视频的站点更新速度一直保持得不错。视频播放器在线看视频的体验很流畅，资源覆盖面广，是我每天必逛的视频导航站。',
    time: '1周前',
  },
  {
    name: '资源达人小李',
    text: '找了好几个视频资源导航站，国产91视频是整理得最清晰的。蓝莓视频和91在线视频的内容分类也做得很好，移动端访问速度也挺快的，希望继续保持更新频率。',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-12">
          用户声音
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl border border-background-200/70 p-6 flex flex-col">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-bold text-sm">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.text}</p>
              <div className="flex items-center gap-1 mt-4 text-accent-500 text-xs">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}